import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { ILogin } from "../../../models/Login";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

const PVInvoiceReport = ({ filter, groupName }: { filter: any, groupName: string | null }) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>; loading: boolean });
  const [openSubModel, setOpenSubModel] = useState({ open: false, singleData: [] } as { open: boolean, singleData: any });
  const [subModelTableData, setSubModelTableData] = useState({ tableData: [], loading: false } as { tableData: Array<{ consultant_Name: string, fromDate: Date, toDate: Date }>; loading: boolean });
  const dt = useRef<any>(null);
  const toast = useRef<any>(null);

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
  const DateFormat = loginObj.date_Format;

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">Prime Vendor Invoice Report</h5>
    </div>
  );
  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });

    const mappedFilter = {
      FromDate: filter?.fromDate,
      ToDate: filter?.ToDate,
      Company_ID: filter?.company_ID ?? null,
      Group_ID: filter?.company_Group_ID ?? null,
    };

    const response = await Fetch("Report_Timesheet/getPVInvoiceAddedCount", "GET", null, `filter=${JSON.stringify(mappedFilter)}`, null);
    if (response) {
      const data: Array<any> = await response.json();
      setTableData({ tableData: data, loading: false });
    }
  };

  const openSubModalFunc = async (rowData: any) => {
    // const mappedFilter = {
    //   FromDate: filter?.fromDate,
    //   ToDate: filter?.ToDate,
    //   PO_IDs: rowData.left_PO_IDs
    // };

    setOpenSubModel({ open: true, singleData: rowData });

    setSubModelTableData({ tableData: rowData.consultants, loading: false });

    // const response = await Fetch("Report_Timesheet/getPVInvoiceLeftDetails", "POST", mappedFilter, null, null);
    // if (response) {
    //   const data: Array<any> = await response.json();
    //   setSubModelTableData({ tableData: data, loading: false });
    // } else setSubModelTableData({ tableData: subModelTableData.tableData, loading: false });
  }

  useEffect(() => {
    loadTableData();
  }, [filter]);

  const isGroupWise = filter?.company_Type === "Company Group Wise";

  const headerGroup = (
    <ColumnGroup>
      {/* First header row */}
      <Row>
        <Column header="SN" rowSpan={1} />
        <Column header="Company & Consultants#" headerStyle={{
          backgroundColor: "#bbd0fd",
          textAlign: "center"
        }} colSpan={2} />
        <Column header="PV Billing Cycles#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} colSpan={6} />
        <Column header="Invoices#" headerStyle={{
          backgroundColor: "#ef97f9",
          textAlign: "center"
        }} colSpan={2} />
      </Row>

      {/* Second header row */}
      <Row>
        <Column header="" />

        <Column header="Company Name" headerStyle={{
          backgroundColor: "#bbd0fd",
          textAlign: "center"
        }} />
        <Column header="Consultant#" headerStyle={{
          backgroundColor: "#bbd0fd",
          textAlign: "center"
        }} />

        <Column header="Weekly#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />
        <Column header="Bi Weekly#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />
        <Column header="Four Weekly#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />
        <Column header="Semi Monthly#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />
        <Column header="Monthly#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />
        <Column header="Custom#" headerStyle={{
          backgroundColor: "#a8f6b0",
          textAlign: "center"
        }} />

        <Column header="Added#" headerStyle={{
          backgroundColor: "#ef97f9",
          textAlign: "center"
        }} />
        <Column header="Pending#" headerStyle={{
          backgroundColor: "#f9f497",
          textAlign: "center"
        }} />
      </Row>
    </ColumnGroup>
  );

  return (
    <>
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        resizableColumns
        showGridlines
        columnResizeMode="expand"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        ref={dt}
        size="small"
        stripedRows
        scrollable
        scrollHeight="70vh"
        value={tableData.tableData}
        header={header}
        loading={tableData.loading}
        headerColumnGroup={headerGroup}
      >
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
        {isGroupWise ? <Column field="company_Name" header={`Company Name of ${groupName || ""}`} headerStyle={{ backgroundColor: "#bbd0fd" }} bodyStyle={{ backgroundColor: "#bbd0fd" }} footerStyle={{ backgroundColor: "#bbd0fd" }} /> : <Column field="company_Name" header="Company" headerStyle={{ backgroundColor: "#bbd0fd" }} bodyStyle={{ backgroundColor: "#bbd0fd" }} footerStyle={{ backgroundColor: "#bbd0fd" }} />}
        <Column field="total_PO" header="No of PO" headerStyle={{ backgroundColor: "#bbd0fd" }} bodyStyle={{ backgroundColor: "#bbd0fd" }} footerStyle={{ backgroundColor: "#bbd0fd" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.total_PO || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="weekly" header="No of PO Weekly" headerStyle={{ backgroundColor: "#a8f6b0" }} bodyStyle={{ backgroundColor: "#a8f6b0" }} footerStyle={{ backgroundColor: "#a8f6b0" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.weekly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="bi_Weekly" header="No of PO BI Weekly" headerStyle={{ backgroundColor: "#a8f6b0" }} bodyStyle={{ backgroundColor: "#a8f6b0" }} footerStyle={{ backgroundColor: "#a8f6b0" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.bi_Weekly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="four_Weekly" header="No of PO Four Weekly" headerStyle={{ backgroundColor: "#a8f6b0" }} bodyStyle={{ backgroundColor: "#a8f6b0" }} footerStyle={{ backgroundColor: "#a8f6b0" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.four_Weekly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="semi_Monthly" header="No of PO Semi Monthly" headerStyle={{ backgroundColor: "#a8f6b0" }} bodyStyle={{ backgroundColor: "#a8f6b0" }} footerStyle={{ backgroundColor: "#a8f6b0" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.semi_Monthly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="monthly" header="No of PO  Monthly" headerStyle={{ backgroundColor: "#a8f6b0" }} bodyStyle={{ backgroundColor: "#a8f6b0" }} footerStyle={{ backgroundColor: "#a8f6b0" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.monthly || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="custom" header="No of  Custom" headerStyle={{ backgroundColor: "#a8f6b0" }} bodyStyle={{ backgroundColor: "#a8f6b0" }} footerStyle={{ backgroundColor: "#a8f6b0" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.custom || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="totalInvoiceLeft" header="No of Pending PV Invoice" headerStyle={{ backgroundColor: "#ef97f9" }} bodyStyle={{ backgroundColor: "#ef97f9" }} footerStyle={{ backgroundColor: "#ef97f9" }} body={(rowData: any) => <p className={rowData.totalInvoiceLeft > 0 ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => rowData.totalInvoiceLeft > 0 ? openSubModalFunc(rowData) : {}}>{rowData.totalInvoiceLeft}</p>} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.totalInvoiceLeft || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
        <Column field="totalInvoiceAdded" header="No of Uploaded PV Invoice" headerStyle={{ backgroundColor: "#f9f497" }} bodyStyle={{ backgroundColor: "#f9f497" }} footerStyle={{ backgroundColor: "#f9f497" }} footer={() => {
          const consultantCount = tableData.tableData.reduce((sum, item) => sum + (item.totalInvoiceAdded || 0), 0);
          return <span className="font-bold">{consultantCount}</span>;
        }} />
      </DataTable>
      <Dialog visible={openSubModel.open} style={{ width: '80vw' }} header={<p>Sub Table</p>} modal className="p-fluid" onHide={() => setOpenSubModel({ open: false, singleData: {} })}>
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          resizableColumns
          showGridlines
          columnResizeMode="expand"
          exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
          size="small"
          stripedRows
          scrollable
          loading={subModelTableData.loading}
          scrollHeight="70vh"
          value={subModelTableData.tableData}
        >
          <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
          <Column field="consultant_Name" header="Consultant Name" />
          {/* <Column field="fromDate" header="From Date" body={(rowData: any) => safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat, false)} />
          <Column field="toDate" header="To Date" body={(rowData: any) => safeFormatDate(rowData.toDate, 'dd/MM/yyyy', DateFormat, false)} /> */}
        </DataTable>
      </Dialog>
      <Toast ref={toast} />
    </>
  );
};

export default PVInvoiceReport;
